module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dev-dash"
  }, [_c('dev-pushes'), _vm._v(" "), _c('dev-builds'), _vm._v(" "), _c('dev-ooo'), _vm._v(" "), _c('dev-pulls')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-07bc38bb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/dev-dash.vue
// module id = 564
// module chunks = 0